import { twMerge } from 'tailwind-merge';

type CardProps = {
  title?: string | React.ReactNode;
  headerElement?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  cardClassName?: string;
  bodyClassName?: string;
  footerClassName?: string;
  onClick?: () => void;
};

const Card = ({
  title,
  headerElement,
  children,
  footer,
  cardClassName,
  bodyClassName,
  footerClassName,
  onClick,
}: CardProps) => {
  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <div className={twMerge('card', cardClassName)} onClick={handleClick}>
      {headerElement ? (
        <div className="card-header border-b-gray-E4E4E4 max-sm:px-3">
          {headerElement}
        </div>
      ) : (
        title && (
          <div className="card-header border-b-gray-E4E4E4 max-sm:px-3">
            <h2 className="w-full card-title">{title}</h2>
          </div>
        )
      )}
      <div className={twMerge('card-body max-md:px-4', bodyClassName)}>
        {children}
      </div>
      {footer && (
        <div
          className={twMerge(
            'card-footer border-t-gray-E4E4E4 justify-end max-sm:justify-center',
            footerClassName,
          )}
        >
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;
